// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼A座317机械"
    },
    {
      "sub": "电力电子技术",
      "tec": "周帅赵德鹏",
      "week": "1-8,11-14周",
      "add": "教学楼A座317机械"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-8周",
        "add": "教学楼A座225电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "11-14周",
        "add": "教学楼A座225电力"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "赵明明李瀚林",
      "week": "1-5周",
      "add": "教学楼D座122新能"
    },
    0
  ],
  "2": [
    {
      "sub": "传热学",
      "tec": "李振南",
      "week": "1-8,11-14周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "电力工程",
      "tec": "王东来",
      "week": "1-8,11-13周",
      "add": "教学楼C座305教务"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "工程伦理",
      "tec": "林雪马自成",
      "week": "1-8周",
      "add": "实训楼E座317管理"
    },
    {
      "sub": "储能材料",
      "tec": "丁艳波",
      "week": "2-8,11-15周",
      "add": "教学楼D座124新能"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电力电子技术",
      "tec": "周帅赵德鹏",
      "week": "1-8,11-14周",
      "add": "教学楼D座124新能"
    },
    {
      "sub": "传热学",
      "tec": "李振南",
      "week": "1-8,11-14周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼A座317机械"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "电力工程",
      "tec": "王东来",
      "week": "2,4,6,8,12周",
      "add": "教学楼D座124新能"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-8周",
        "add": "教学楼B座425能动"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "11-14周",
        "add": "教学楼B座425能动"
      }
    ],
    {
      "sub": "储能材料",
      "tec": "丁艳波",
      "week": "2-8,11-15周",
      "add": "教学楼D座124新能"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
